module.exports = __webpack_public_path__ + "static/media/error.7063fe46.png";